import {
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  Output
} from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { PermissionsService } from '../../services/permissions/permissions.service';
import { Directionality } from '@angular/cdk/bidi';
import { UserData } from '../../dto/user-data';
import { Subject, take, takeUntil } from 'rxjs';
import { UsersContainerPopupInput } from '../users-container-popup/users-container-popup-input';
import { UsersContainerPopupComponent } from '../users-container-popup/users-container-popup.component';
import { NgIf } from '@angular/common';
import { MatButton } from '@angular/material/button';

@Component({
    selector: 'pcp-users-select',
    templateUrl: './users-select.component.html',
    styleUrl: './users-select.component.scss',
    imports: [NgIf, MatButton]
})
export class UsersSelectComponent {
  constructor(
    public dialog: MatDialog,
    private permissions: PermissionsService,
    private dir: Directionality,
    private cd: ChangeDetectorRef
  ) {}

  @Input()
  value: string[] | string | null = null;
  @Input()
  multiSelect = true;
  @Input()
  disabled = false;
  @Input()
  placeholder: string | null = null;
  @Input()
  users: UserData[] | null = null;

  @Output()
  valueChange = new EventEmitter<string[] | string | null>();
  onDestroy$ = new Subject<void>();

  ngOnDestroy() {
    this.onDestroy$.next();
  }

  selectUsers() {
    if (!this.users) {
      return;
    }
    let selected: string[] | string | null = null;
    if (this.users && this.value) {
      if (this.multiSelect) {
        selected = this.users
          .filter((c) => this.value?.includes(c.id))
          .map((u) => u.id);
      } else {
        selected = this.users.find((c) => this.value === c.id)?.id ?? null;
      }
    }
    const data: UsersContainerPopupInput = {
      users: this.users,
      value: selected,
      canEdit: !this.disabled,
      multiSelect: this.multiSelect
    };
    this.dialog
      .open(UsersContainerPopupComponent, {
        direction: this.dir.value,
        data: data
      })
      .afterClosed()
      .pipe(take(1), takeUntil(this.onDestroy$))
      .subscribe(() => {
        this.value = data.value;
        this.valueChange.emit(data.value);
      });
  }

  getDisplayValue() {
    if (!this.value) {
      return this.placeholder;
    }
    if (this.multiSelect) {
      if (this.value.length === 1) {
        return this.value[0];
      } else if (this.value && this.value.length > 1) {
        return this.value.length + ' ' + $localize`Users`;
      } else {
        return this.placeholder;
      }
    }
    return this.value;
  }
}
